/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DocumentSubType,
    DocumentSubTypeFromJSON,
    DocumentSubTypeFromJSONTyped,
    DocumentSubTypeToJSON,
    DocumentType,
    DocumentTypeFromJSON,
    DocumentTypeFromJSONTyped,
    DocumentTypeToJSON,
    Interrogatory,
    InterrogatoryFromJSON,
    InterrogatoryFromJSONTyped,
    InterrogatoryToJSON,
} from './';

/**
 * 
 * @export
 * @interface DocumentView
 */
export interface DocumentView {
    /**
     * 
     * @type {string}
     * @memberof DocumentView
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentView
     */
    name?: string | null;
    /**
     * 
     * @type {Array<Interrogatory>}
     * @memberof DocumentView
     */
    interrogatories?: Array<Interrogatory> | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentView
     */
    jurisdiction?: string;
    /**
     * 
     * @type {DocumentType}
     * @memberof DocumentView
     */
    documentType?: DocumentType;
    /**
     * 
     * @type {DocumentSubType}
     * @memberof DocumentView
     */
    documentSubType?: DocumentSubType;
}

export function DocumentViewFromJSON(json: any): DocumentView {
    return DocumentViewFromJSONTyped(json, false);
}

export function DocumentViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentView {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'interrogatories': !exists(json, 'interrogatories') ? undefined : (json['interrogatories'] === null ? null : (json['interrogatories'] as Array<any>).map(InterrogatoryFromJSON)),
        'jurisdiction': !exists(json, 'jurisdiction') ? undefined : json['jurisdiction'],
        'documentType': !exists(json, 'documentType') ? undefined : DocumentTypeFromJSON(json['documentType']),
        'documentSubType': !exists(json, 'documentSubType') ? undefined : DocumentSubTypeFromJSON(json['documentSubType']),
    };
}

export function DocumentViewToJSON(value?: DocumentView | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'interrogatories': value.interrogatories === undefined ? undefined : (value.interrogatories === null ? null : (value.interrogatories as Array<any>).map(InterrogatoryToJSON)),
        'jurisdiction': value.jurisdiction,
        'documentType': DocumentTypeToJSON(value.documentType),
        'documentSubType': DocumentSubTypeToJSON(value.documentSubType),
    };
}


